import { allowedYearRange } from '../../components/Inputs/YearRange/YearRange';
import { RangeOflong } from '../../generated/model/rangeOflong';

export const getYearsFromRange = (years?: RangeOflong) => {
  const columns = [];

  const fromYear = years?.from || allowedYearRange.from;
  const toYear = years?.to || allowedYearRange.to;

  for (let year = toYear; year >= fromYear; year--) {
    columns.push(year);
  }

  return columns;
};
